module.exports = __webpack_public_path__ + "static/media/adela-linda-mobile.2f4ec17e.jpg";